import {
    OperationVariables,
    QueryResult,
    MutationHookOptions,
    MutationTuple,
    QueryHookOptions,
    SubscriptionHookOptions,
    useMutation,
    useQuery,
    useSubscription,
    SubscriptionResult,
    TypedDocumentNode,
} from "@apollo/client";
import { DocumentNode } from "graphql";
import { useCurrentMeeting } from "conference/components/meeting-page/contexts/currentMeeting";
import { chattoClients } from "conference/apollo-client/chatto/clients";
import { useEffect } from "react";

function useHttpAuthContextSetter(options: OperationVariables) {
    const currentMeeting = useCurrentMeeting();

    Object.assign(options, {
        client: chattoClients.http,
        context: {
            token: currentMeeting.selfIdentifier,
        },
    });
}

export function useChattoHttpQuery<TData = any, TVariables = OperationVariables>(
    query: DocumentNode,
    options: QueryHookOptions<TData, TVariables> = {},
): QueryResult<TData, TVariables> {
    useHttpAuthContextSetter(options);
    return useQuery(query, options);
}

type MutationOptions<TData = any, TVariables = OperationVariables> = MutationHookOptions<TData, TVariables> & {
    executeOnMount?: boolean;
};

export function useChattoHttpMutation<TData = any, TVariables = OperationVariables>(
    mutation: TypedDocumentNode<TData, TVariables> | DocumentNode,
    options: MutationOptions<TData, TVariables> = {},
): MutationTuple<TData, TVariables> {
    useHttpAuthContextSetter(options);
    const res = useMutation(mutation, options);
    useEffect(() => {
        if (options?.executeOnMount) res[0]();
    }, []);
    return res;
}

export function useChattoWsSubscription<TData = any, TVariables = OperationVariables>(
    subscription: DocumentNode,
    options: SubscriptionHookOptions<TData, TVariables> = {},
): SubscriptionResult<TData, TVariables> {
    const currentMeeting = useCurrentMeeting();
    options.client = chattoClients.ws;
    options.context = {
        token: currentMeeting.selfIdentifier,
    };
    return useSubscription(subscription, options);
}
